export const useStyles = () => ({
  formContainer: {
    maxWidth: 720,
    padding: '32px 0px 23px',
    borderRadius: 4,
    mx: 4,
  },
});
